import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { REMOVE_USER_PREFERENCE_REQUEST, REMOVE_USER_PREFERENCE_SUCCESS, REMOVE_USER_PREFERENCE_ERROR } from '../constants/ActionTypes';
import { push } from 'connected-react-router';
import { removeUserPreference as removeUserPreferenceLocally } from './modifyUserPreference';

function removeUserPreferenceRequest() {
    return {
        type: REMOVE_USER_PREFERENCE_REQUEST,
    };
}

function removeUserPreferenceSuccess() {
    return {
        type: REMOVE_USER_PREFERENCE_SUCCESS,
    };
}

function removeUserPreferenceError(error) {
    return {
        type: REMOVE_USER_PREFERENCE_ERROR,
        error,
    };
}

export default function removeUserPreference(preference, body) {
    return (dispatch, getState, fetch) => {
        const { uberToken, locale, config, router } = getState();
        const { location = {} } = router;
        const { country } = locale;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        const request = Person.userPreferenceRemove({
            baseUrl,
            brandId,
            country,
            preference,
            body,
            uberToken,
            clientId,
        });

        dispatch(removeUserPreferenceLocally(preference, body));
        dispatch(removeUserPreferenceRequest(preference, body.values));

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response;

                if (ok) {
                    return response.json().then(() => dispatch(removeUserPreferenceSuccess()));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(removeUserPreferenceError(error));
                throw error;
            });
    };
}
